import { useState, useEffect } from "react";
import { useGetProjectsQuery } from "src/services/ProjectService";

export const useGetAllProjects = () => {
  const [allProjects, setAllProjects] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetProjectsQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setAllProjects(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { allProjects, isDataLoading };
};
